((Drupal, once) => {
  "use strict";

  Drupal.behaviors.assignmentsPages = {
    attach(context) {
      const filtersWrapper = context.querySelector(
        ".assignments-filters-inner"
      );

      if (!filtersWrapper) return;

      once('assignments-filter-toggle', '.assignments-filters-wrapper .close-btn', context).forEach((closeBtn) => {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;

        if (isMobile) {
          filtersWrapper.classList.add('hidden');
          closeBtn.textContent = 'Open Filter';
        } else {
          filtersWrapper.classList.remove('hidden');
          closeBtn.textContent = 'Close Filter';
        }

        closeBtn.addEventListener("click", (event) => {
          event.preventDefault();
          filtersWrapper.classList.toggle("hidden");

          if (filtersWrapper.classList.contains("hidden")) {
            closeBtn.textContent = "Open Filters";
          } else {
            closeBtn.textContent = "Close Filters";
          }
        });
      });
    },
  };
})(Drupal, once);
